import AdCard from 'client/common/components/ad-card';

import './AdCard.css';

export default AdCard;
